import { type Accessor, For, createEffect, createMemo } from "solid-js";

import Icon from "@/components/Icon";
import {
  casinoSubCategoryList,
  sportsSubCategoryListBetby,
  sportsSubCategoryListFirst,
  subCategoryIconMap,
} from "@/components/PC/Modals/GlobalSearch/constants";
import { globalSearch, useGlobalSearch } from "@/hooks/useGlobalSearch";
import { useI18n } from "@/i18n";
import { isMobile } from "@/lib/isMobile";
import { sysConfigStore } from "@/stores/sysConfigStore";

type SearchSubCategoryProps = {
  debouncedFetch: (isLoadMore?: boolean) => void;
  gameItemPreviewScrollToTop: () => void;
};

export const SearchSubCategory = (props: SearchSubCategoryProps) => {
  const { t } = useI18n();

  const { setCurSubCategoryIdx, setSearchCasinoParams, setSearchSportsParams } =
    useGlobalSearch();

  const handleSubCategoryClick = async (
    item: number | string,
    idx: Accessor<number>,
  ) => {
    if (globalSearch().curMainCategory === "Casino") {
      setSearchCasinoParams({
        page: 1,
        maker_tag: "",
        gclass: item,
      });
    } else {
      setSearchSportsParams({
        page: 1,
        sport_id: item as number,
      });
    }
    setCurSubCategoryIdx(idx());

    // 先加载数据，数据加载完成后再跳回顶部
    await props.debouncedFetch();
    props.gameItemPreviewScrollToTop();
  };

  const subCategoryList = createMemo(() => {
    const sportType = sysConfigStore.sport_config.sport_priority_type;

    const sportsSubCategoryList = () => {
      if (sportType === 1) return sportsSubCategoryListBetby;
      if (sportType === 2) return sportsSubCategoryListFirst;
      return [];
    };

    return globalSearch().curMainCategory === "Casino"
      ? casinoSubCategoryList
      : sportsSubCategoryList();
  });

  // 获取当前子分类的选中值
  const getCurrentSubCategoryValue = createMemo(() => {
    return globalSearch().curMainCategory === "Casino"
      ? globalSearch().searchCasinoParams.gclass
      : globalSearch().searchSportsParams.sport_id;
  });

  createEffect(() => {
    console.log("searchStore.curMainCategory", subCategoryList());
  });

  return (
    // 子分类列表
    <div
      class="flex flex-wrap"
      classList={{
        "gap-[5px]": isMobile(),
        "gap-[22px]": !isMobile(),
      }}
    >
      <For each={subCategoryList()}>
        {(item, idx) => {
          return (
            <div
              class="flex h-[36px] cursor-pointer items-center font-[600]"
              classList={{
                "gap-[4px] px-[8px] text-[14px] ": isMobile(),
                "gap-[8px] px-[10px] text-[15px] ": !isMobile(),

                "text-general-assist":
                  getCurrentSubCategoryValue() === item.value, // 选中 h5
                "text-general-darkzi":
                  getCurrentSubCategoryValue() !== item.value, // 未选中 h5
              }}
              onClick={(e) => {
                handleSubCategoryClick(item.value, idx);
                if (isMobile()) {
                  e.currentTarget.scrollIntoView({
                    behavior: "smooth",
                    block: "nearest",
                    inline: "center",
                  });
                }
              }}
            >
              <Icon
                name={
                  subCategoryIconMap[globalSearch().curMainCategory][item.key]
                }
                class={`${isMobile() ? "size-[16px]" : "size-[20px]"} ${
                  globalSearch().curSubCategoryIdx === idx()
                    ? "text-general-assist"
                    : "text-general-icon"
                }`}
              />

              {item.label && <span>{t(item.label)}</span>}
            </div>
          );
        }}
      </For>
    </div>
  );
};
